import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Artstamm } from '../../types/artstamm';
import { Kopfau } from '../../types/kopfau';
import { CommonModule } from '@angular/common';
import { UiCoreModule } from '@softline/ui-core';
import { LoadArchiveFilePipe } from '../../pipes/load-archive-file.pipe';

type Media = any;

const BASE_URL = 'https://www.feichtinger.biz/index.php'

@Component({
    selector: 'soft-beweau-card',
    templateUrl: './beweau-card.component.html',
    styleUrls: ['./beweau-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, UiCoreModule, LoadArchiveFilePipe]
})
export class BeweauCardComponent {

  hauptartikel = input<Artstamm>();
  images = input.required<Media[]>();
  preisebene = input<Kopfau['preisebene'] | undefined>();
  price = input<number | undefined>();
  url = input<string | undefined>();

  priceTapped = output<void>();
  beweausTapped = output<void>();
  imageTapped = output<void>();

  constructor() {}

  async openLink(url: string | undefined): Promise<void> {
    let finalURL = BASE_URL;

    if (url && url?.length > 0)
      finalURL += `?cl=details&anid=${url}`;

    window.open(finalURL ?? "");
  }
}
